import React, { useState, useContext } from "react";
import { UserContext } from "./UserContext";
import Header from "./Header";
import { useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Import eye icons
import { toast, ToastContainer, Zoom } from "react-toastify";

const ChangePassword = () => {
  const { user, token } = useContext(UserContext);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState("");
    
  const role = user.role;
  const navigate = useNavigate();

  const handleSubmit = async () => {
    setError(""); // clear old error

    if (!oldPassword || !newPassword || !confirmPassword) {
        setError("⚠️ All fields are required");
        return;
    }

    if (newPassword.length < 6) {
        setError("⚠️ New password must be at least 6 characters long");
        return;
    }

    if (oldPassword === newPassword) {
        setError("⚠️ Old Password and New Password cannot be the same");
        return;
    }

    if (newPassword !== confirmPassword) {
        setError("⚠️ New password and confirm password do not match");
        return;
    }

    setLoading(true);

    try {
        const res = await fetch("https://sitiplay.com/portal_php/change_password.php", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ oldPassword, newPassword }),
        });

        const data = await res.json();

        if (res.ok && data.status === "success") {
        // ✅ success case
        setError(""); 
        toast.success(data.message);
        if (role === "superadmin") {
            navigate("/superadmin");
        } else if (role === "admin") {
            navigate("/admin");
        } else {
            navigate("/operator");
        }
        } else {
        // ❌ show inline error
        toast.error(data.error || "Failed to change password");
        }
    } catch (err) {
        // console.error("Change password error:", err);
        toast.warn("Network error while changing password");
    } finally {
        setLoading(false);
    }
  };

  const handleClose = async () => {
    if (role === "superadmin") {
        navigate("/superadmin");
    } else if (role === "admin") {
        navigate("/admin");
    } else {
        navigate("/operator");
    }
  }

  return (
    <div className="change-password-container">
      <Header />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        transition={Zoom}
      />
      <div className="change-password">
        <h2>Change Password</h2>

        <div className="password-input-wrapper">
          <input
            type={showOldPassword ? "text" : "password"}
            placeholder="Old Password"
            value={oldPassword}
            onChange={(e) => { 
                setOldPassword(e.target.value); 
                setError(""); 
            }}
          />
          <span 
            className="password-toggle-icon"
            onClick={() => setShowOldPassword(!showOldPassword)}
          >
            {showOldPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>

        <div className="password-input-wrapper">
          <input
            type={showNewPassword ? "text" : "password"}
            placeholder="New Password"
            value={newPassword}
            onChange={(e) => { 
                setNewPassword(e.target.value); 
                setError(""); 
            }}
          />
          <span 
            className="password-toggle-icon"
            onClick={() => setShowNewPassword(!showNewPassword)}
          >
            {showNewPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>

        <div className="password-input-wrapper">
          <input
            type={showConfirmPassword ? "text" : "password"}
            placeholder="Confirm New Password"
            value={confirmPassword}
            onChange={(e) => { 
                setConfirmPassword(e.target.value); 
                setError(""); 
            }}
          />
          <span 
            className="password-toggle-icon"
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
          >
            {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>
        {newPassword && (
            <div className="password-strength">
                <div 
                className="password-strength-bar"
                style={{
                    width: `${Math.min((newPassword.length / 12) * 100, 100)}%`,
                    background: newPassword.length < 6 ? '#f56565' : 
                            newPassword.length < 9 ? '#ed8936' : '#48bb78'
                }}
                />
            </div>
        )}
        {error && <p className="error">{error}</p>}
        <div className="add-cancel">
          <button onClick={handleSubmit} disabled={loading}>
            {loading ? "Saving..." : "Save"}
          </button>
          <button onClick={handleClose} className="cancel-btn">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
